import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedUiAddChildProfileModule } from '@se-po/shared-ui-add-child-profile'
import { SharedUiGuardianInviteInfoModule } from '@se-po/shared-ui-guardian-invite-info'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiParentContactInfoModule } from '@se-po/shared-ui-parent-contact-info'
import { SharedUiPersonaAvatarModule } from '@se-po/shared-ui-persona-avatar'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeIconModule, seFeIconSpotIdCard } from 'se-fe-icon'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTranslationsModule } from 'se-fe-translations'

import { HouseholdReviewComponent } from './household-review/household-review.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeTranslationsModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconSpotIdCard]),
    SeFeToastModule,
    SharedUiAddChildProfileModule,
    SharedUiGuardianInviteInfoModule,
    SharedUiHighlightLabelModule,
    SharedUiParentContactInfoModule,
    SharedUiPersonaAvatarModule
  ],
  declarations: [HouseholdReviewComponent],
  exports: [HouseholdReviewComponent],
})
export class SharedFeatureHouseholdReviewModule {}
